/* eslint-disable @typescript-eslint/naming-convention */
import { OutTopic } from 'embedded/api/out/OutTopic';
import { layoutLoadedTopic } from 'embedded/api/out/messages/LayoutLoadedMessage';
import { AnyOutMessageTopic } from 'embedded/api/out/OutMessageTopic';
import { authenticationStatusChangedTopic } from 'embedded/api/out/messages/AuthenticationStatusChangedMessage';

export function bootstrapOutTopics(): Record<OutTopic, AnyOutMessageTopic> {
    return {
        LAYOUT_LOADED: layoutLoadedTopic,
        RELOAD_REQUIRED: { subscriptions: [] },
        REAUTHENTICATION_REQUIRED: { subscriptions: [] },
        AUTHENTICATION_STATUS_CHANGED: authenticationStatusChangedTopic,
    };
}
